module.exports = __webpack_public_path__ + "img/info-circle.e22c8a8b.svg";